import Main from './AiInventoryMain'
import New from './AiInventoryNew'
import DaiRegistration from './AiInventoryDaiRegistration'
import Show from './AiInventoryShow'
import Edit from './AiInventoryEdit'
import Indicators from './AiInventoryIndicators'

export default { Main, New, DaiRegistration, Show, Edit, Indicators }
